import axios from "axios";
import { getItem, setItem } from "@/helpers/persistanceStorage";
import router from "@/router/index";
import store from "@/store/index";

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL || "https://api-doc.florida55.ru",
});

let isRefreshing = false;
let refreshPromise = null;

// Request interceptor - добавляет токен к каждому запросу
instance.interceptors.request.use(
  function (config) {
    const token = getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Response interceptor - обрабатывает 401 ошибки и делает refresh
instance.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;

    // Если нет конфига запроса, пробрасываем ошибку
    if (!originalRequest) {
      return Promise.reject(error);
    }

    // Проверяем, что это 401 ошибка
    const isUnauthorized = error.response && error.response.status === 401;
    
    // Проверяем, что это не сам refresh endpoint
    const requestUrl = originalRequest.url || '';
    const isRefreshEndpoint = requestUrl === '/refresh' || requestUrl.endsWith('/refresh');

    // Если это 401 и не refresh endpoint, пытаемся обновить токен
    if (isUnauthorized && !isRefreshEndpoint) {
      // Если уже идет refresh, ждем его
      if (isRefreshing && refreshPromise) {
        try {
          await refreshPromise;
          // После успешного refresh повторяем запрос
          const token = getItem("accessToken");
          if (token) {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return instance(originalRequest);
          }
        } catch (refreshError) {
          // Если refresh не удался, редиректим на login
          if (router.history.current.name !== "login") {
            router.push({ name: "login" });
          }
          return Promise.reject(refreshError);
        }
      }

      // Если нет токена, сразу редиректим на login
      const currentToken = getItem("accessToken");
      if (!currentToken) {
        if (router.history.current.name !== "login") {
          router.push({ name: "login" });
        }
        return Promise.reject(error);
      }

      // Начинаем процесс refresh
      isRefreshing = true;
      refreshPromise = store.dispatch('auth/refreshToken')
        .then(() => {
          // Refresh успешен - повторяем запрос
          const token = getItem("accessToken");
          if (token) {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return instance(originalRequest);
          } else {
            throw new Error('No token after refresh');
          }
        })
        .catch((refreshError) => {
          // Refresh не удался - очищаем токен и редиректим на login
          setItem('accessToken', null);
          if (router.history.current.name !== "login") {
            router.push({ name: "login" });
          }
          throw refreshError;
        })
        .finally(() => {
          // Сбрасываем флаги в любом случае
          isRefreshing = false;
          refreshPromise = null;
        });

      return refreshPromise;
    }

    // Для других 401 ошибок (включая refresh endpoint) редиректим на login
    if (isUnauthorized && router.history.current.name !== "login") {
      router.push({ name: "login" });
    }

    return Promise.reject(error);
  }
);

export default instance;
